import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  icon = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#c75a4a] hover:bg-[#a0483b] text-white shadow-lg hover:shadow-xl focus:ring-[#c75a4a] border border-transparent',
    secondary: 'bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm border border-white/20',
    outline: 'bg-transparent border-2 border-[#c75a4a] text-[#c75a4a] hover:bg-[#c75a4a] hover:text-white',
    white: 'bg-white text-[#1e2a4a] hover:bg-gray-50 shadow-md'
  };
  const sizes = {
    sm: 'text-sm px-5 py-2.5',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  return <motion.button whileHover={{
    scale: 1.005
  }} whileTap={{
    scale: 0.995
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-370">
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-371" />}
    </motion.button>;
}